import React from 'react'

const PriceCard = (props) => {
  return (
    <div className="relative">
      
      
      <div className="relative h-full p-3 sm:p-6 lg:p-8 rounded-2xl sm:rounded-3xl flex flex-col transition-all duration-300 hover:scale-105 border bg-white/90 backdrop-blur-sm shadow-xl border-white/20 hover:bg-white">
        
        {/* En-tête */}
        <div className="text-center mb-4 sm:mb-6 lg:mb-8">
          <h3 className="text-xs sm:text-base lg:text-lg font-bold uppercase tracking-wider mb-2 sm:mb-3 lg:mb-4 text-gray-600">
            {props.title}
          </h3>
          <div className="mb-3 sm:mb-4 lg:mb-6">
            <span className="text-xl sm:text-3xl lg:text-5xl font-bold text-gray-900">{props.price}</span>
            <span className="text-gray-500 ml-1 sm:ml-2 text-xs sm:text-sm lg:text-base">/an</span>
          </div>
        </div>
        
        {/* Liste des fonctionnalités */}
        <div className="flex-grow space-y-2 sm:space-y-3 lg:space-y-4 mb-4 sm:mb-6 lg:mb-8">
          {props.info.map((feature, index) => (
            <div key={index} className="flex items-start space-x-2 sm:space-x-3">
              <div className="w-4 h-4 sm:w-5 sm:h-5 lg:w-6 lg:h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 bg-gradient-to-br from-primary to-red-600">
                <svg className="w-2 h-2 sm:w-2.5 sm:h-2.5 lg:w-3 lg:h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path>
                </svg>
              </div>
              <span className="text-gray-700 text-xs sm:text-xs lg:text-sm leading-relaxed">{feature}</span>
            </div>
          ))}
        </div>
        
        {/* Bouton CTA */}
        <a 
          href='#contact' 
          className="w-full py-2 sm:py-3 lg:py-4 px-3 sm:px-4 lg:px-6 rounded-xl sm:rounded-2xl font-semibold text-center text-xs sm:text-sm lg:text-base transition-all duration-300 transform hover:scale-105 hover:shadow-lg bg-gradient-to-r from-primary to-red-600 text-white shadow-lg"
        >
          <span className="flex items-center justify-center space-x-1 sm:space-x-2">
            <span>Nous rejoindre</span>
            <svg className="w-3 h-3 sm:w-3 sm:h-3 lg:w-4 lg:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
            </svg>
          </span>
        </a>
        
        {/* Élément décoratif */}
        {/* <div className="absolute bottom-0 right-0 w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20 rounded-tl-2xl sm:rounded-tl-3xl bg-gradient-to-br from-gray-100/50 to-red-100/20"></div> */}
      </div>
    </div>
  )
}

export default PriceCard